import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

import commonMessages from '../../messages';

import messages from './messages';
import { type Props } from './types';

export const SwitchModal: React.FC<Props> = ({
	onSwitch,
	onSwitchAttemptCancel,
	isSwitchDialogOpen,
	isLoading,
}) => {
	const { formatMessage } = useIntl();
	return (
		<ModalTransition>
			{isSwitchDialogOpen && (
				<Modal onClose={onSwitchAttemptCancel}>
					<ModalHeader>
						<ModalTitle appearance="warning">{formatMessage(messages.title)}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<Text as="p">{formatMessage(messages.description)}</Text>
					</ModalBody>
					<ModalFooter>
						<Button
							appearance="subtle"
							onClick={(_, analyticsEvent) => {
								fireUIAnalytics(analyticsEvent, 'closeSwitchModalButton');

								return onSwitchAttemptCancel();
							}}
							autoFocus
						>
							{formatMessage(commonMessages.cancel)}
						</Button>
						<Button isLoading={isLoading} appearance="warning" onClick={onSwitch}>
							{formatMessage(messages.turnOff)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
